import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1
    },
    content: {
        marginTop: 0,
        flex: 1,
        flexDirection: 'row'
    },
    view: {
        flex: 1,
        flexDirection: 'row'
    },
    list: {
        flex: 4,
        maxWidth: 400
    },
    detail: {
        flex: 8
    }
});
